import { PropsWithChildren } from "react";
import { cn } from "@utils/tailwind.util";

interface Props extends React.HTMLAttributes<HTMLParagraphElement> {
  className?: string;
}

export function Paragraph({ className, children }: PropsWithChildren<Props>) {
  return (
    <p
      className={cn(
        "text-gray-450 dark:text-invertedPrimary80 text-center text-sm font-[400] leading-5 non-selectable",
        className
      )}
    >
      {children}
    </p>
  );
}
